import {MOON_500, RED_500} from '@wandb/weave/common/css/globals.styles';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

export const JobDrawerInner = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;
JobDrawerInner.displayName = 'S.JobDrawerInner';

export const JobDrawerInnerMain = styled.div`
  flex: 1 1 auto;
  margin-bottom: 16px;
`;
JobDrawerInnerMain.displayName = 'S.JobDrawerInnerMain';

export const Header = styled.div`
  font-weight: 600;
  font-size: 20px;
  line-height: 32px;
`;
Header.displayName = 'S.Header';

export const CloseButton = styled.div`
  text-align: right;
  flex: 1 1 auto;
`;
CloseButton.displayName = 'S.CloseButton';

export const LabelRow = styled.div`
  display: flex;
  align-items: center;
  margin-top: 16px;
  margin-bottom: 4px;
`;
LabelRow.displayName = 'S.LabelRow';

export const Label = styled.div`
  font-weight: 600;
  font-size: 16px;
  line-height: 32px;
`;
Label.displayName = 'S.Label';

export const HintText = styled.div`
  font-size: 14px;
  line-height: 20px;
  color: ${MOON_500};
  margin-top: 4px;
`;
HintText.displayName = 'S.HintText';

export const PriorityHints = styled.div`
  margin-top: 8px;
`;

PriorityHints.displayName = 'S.PriorityHints';

export const PriorityHint = styled.div`
  display: flex;
  align-items: center;
  font-size: 14px;
  line-height: 26px;
  color: ${MOON_500};
  & svg {
    margin-right: 4px;
  }
`;
PriorityHint.displayName = 'S.PriorityHint';

export const CenteredFlex = styled.div`
  display: flex;
  align-items: center;
`;
CenteredFlex.displayName = 'S.CenteredFlex';

export const Error = styled.div`
  color: ${RED_500};
  font-size: 14px;
`;
Error.displayName = 'S.Error';

export const ToggleConfig = styled.div`
  display: flex;
  justify-content: flex-start;
  flex: 1 1 auto;
`;
ToggleConfig.displayName = 'S.ToggleConfig';

export const SuccessfulQueue = styled.div`
  display: flex;
  align-items: center;
`;
SuccessfulQueue.displayName = 'S.SuccessfulQueue';

export const SuccessfulQueueMessage = styled.div`
  margin-left: 8px;
`;
SuccessfulQueueMessage.displayName = 'S.SuccessfulQueueMessage';
